module.exports = __webpack_public_path__ + "img/404-image.4d2f2550.png";